import { render, staticRenderFns } from "./MisDatosComponent.vue?vue&type=template&id=d242a384&scoped=true&"
import script from "./MisDatosComponent.vue?vue&type=script&lang=ts&"
export * from "./MisDatosComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MisDatosComponent.vue?vue&type=style&index=0&id=d242a384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d242a384",
  null
  
)

export default component.exports